import axios from 'axios'

export default{
  namespaced: true,
  actions: {
    async getRoutineTasks ({commit, state, rootState}, args) {
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/routineTasks`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getRoutineTaskInstances ({commit, state, rootState}, args) {
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/routineTaskInstances?startDate=${args.startDate}&endDate=${args.endDate}`
      return axios.get(apiPath).then((result) => {
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async saveRoutineTask ({rootState}, args) {
      console.log('Saving task: ' + JSON.stringify(args.task, null, 2))
      args.task.companyId = rootState.userCurrentCompany.companyId
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/routineTasks`
      return axios.post(apiPath, args.task).then((result) => {
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getMyRoutineTasks ({commit, state, rootState}) {
      console.log('Getting tasks for user')
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/routineTaskInstancesForThisUser`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getLocationResultsForList ({commit, state, rootState}, args) {
      console.log('Getting location results for list')
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/routineTaskInstance/${args.instanceId}/locationsList`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getLocationResult ({commit, state, rootState}, args) {
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/routineTaskInstance/${args.instanceId}/result/${args.resultId}/fordisplay`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async beginOrResumeRoutineTask ({commit, state, rootState}, args) {
      console.log('args', args)
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/routineTaskInstance/${args.instanceId}/result/${args.resultId}`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async saveRoutineTaskProgress ({commit, state, rootState}, saveProgressRequest) {
      try {
        console.log('Saving Event with args: ' + JSON.stringify(saveProgressRequest, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/routineTaskInstance/${saveProgressRequest.progress.instanceId}/result/${saveProgressRequest.progress.resultId}`, { progress: saveProgressRequest.progress }
        )
        //  .then(result => commit('updateEventForEdit', saveProgressRequest.eventProgress))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/routinetasks.js